import React from "react";

function BS4_Inputs() {
  return (
    <div>
      <h1>BS4_Inputs Component</h1>
      <p>This is the BS4_Inputs tutorial page content.</p>
    </div>
  );
}

export default BS4_Inputs;
